<template>
  <div class="page-container">
    <!-- Кривая линия -->
    <div class="curve-line" v-if="showCurve">
      <svg class="curve-svg" viewBox="0 0 100 1000" preserveAspectRatio="none">
        <path class="curve-path" d="M50,0 C70,50 30,150 50,200 C70,250 30,350 50,400 C70,450 30,550 50,600 C70,650 30,750 50,800 C70,850 30,950 50,1000" />
      </svg>
    </div>
    
    <section class="section-pure animate-element">
      <h2 class="section-pure-title" ref="sectionTitle">
        {{ $t('pure.adva')}}
      </h2>

      <div class="section-pure-img animate-element" ref="invoBanner">
        <img src="/img/pure.jpg" alt="invo">
      </div>

      <section class="section-pure-block animate-element">
        <h2>{{ $t('pure.hisecury')}}</h2>
        <ul>
          <li>{{ $t('pure.material')}}</li>
          <li>{{ $t('pure.new')}}</li>
          <li>{{ $t('pure.rule')}}</li>
        </ul>
      </section>

      <section class="section-pure-block animate-element">
        <h2>{{ $t('pure.srok')}}</h2>
        <ul>
          <li>{{ $t('pure.gel')}}</li>
          <li>{{ $t('pure.memory')}}</li>
          <li>{{ $t('pure.damage')}}</li>
        </ul>
      </section>

      <section class="section-pure-block animate-element">
        <h2>{{ $t('pure.nature')}}</h2>
        <ul>
          <li>{{ $t('pure.implants')}}</li>
          <li>{{ $t('pure.forms')}}</li>
          <li>{{ $t('pure.results')}}</li>
        </ul>
      </section>

      <section class="section-pure-block animate-element">
        <h2>{{ $t('pure.psyco')}}</h2>
        <ul>
          <li>{{ $t('pure.note')}}</li>
          <li>{{ $t('pure.quality')}}</li>
          <li>{{ $t('pure.updating')}}</li>
        </ul>
      </section>

      <section class="section-pure-block animate-element">
        <h2>{{ $t('pure.help')}}</h2>
        <ul>
          <li>{{ $t('pure.implants2')}}</li>
          <li>{{ $t('pure.helps')}}</li>
          <li>{{ $t('pure.backtolife')}}</li>
        </ul>
      </section>

      <section class="section-pure-block animate-element">
        <h2>{{ $t('pure.solutions')}}</h2>
        <ul>
          <li>{{ $t('pure.bigchoice')}}</li>
          <li>{{ $t('pure.opportunity')}}</li>
          <li>{{ $t('pure.esthetic')}}</li>
        </ul>
      </section>

      <section class="section-pure-block animate-element">
        <h2>{{ $t('pure.methods')}}</h2>
        <ul>
          <li>{{ $t('pure.protocols') }}</li>
          <li>{{ $t('pure.minimal')}}</li>
          <li>{{ $t('pure.tools')}}</li>
        </ul>
      </section>

      <section class="section-pure-block animate-element">
        <h2>{{ $t('pure.discovery')}}</h2>
        <ul>
          <li>{{ $t('pure.proofs')}}</li>
          <li>{{ $t('pure.standarts')}}</li>
          <li>{{ $t('pure.waytouse')}}</li>
        </ul>
      </section>

      <section class="section-pure-block animate-element">
        <h2>{{ $t('pure.conclusion')}}</h2>
        <p>{{ $t('conctitle')}}</p>
      </section>

      <section class="section-pure-block animate-element">
        <h2 class="animate-element">{{ $t('pure.list')}}</h2>
        <ul class="animate-element">
            <li>{{ $t('pure.list1')}}</li>
            <li>{{ $t('pure.list2')}}</li>
            <li>{{ $t('pure.list3')}}</li>
            <li>{{ $t('pure.list4')}}</li>
            <li>{{ $t('pure.list5')}}</li>
            <li>{{ $t('pure.list6')}}</li>
            <li>{{ $t('pure.list7')}}</li>
            <li>{{ $t('pure.list8')}}</li>
            <li>{{ $t('pure.list9')}}</li>
            <li>{{ $t('pure.list10')}}</li>
            <li>{{ $t('pure.list11')}}</li>
            <li>{{ $t('pure.list12')}}</li>
            <li>{{ $t('pure.list13')}}</li>
            <li>{{ $t('pure.list14')}}</li>
            <li>{{ $t('pure.list15')}}</li>
        </ul>

    </section>

</section>

  </div>
</template>


<script>
export default {
  data() {
    return {
      showCurve: true
    }
  },

  mounted() {
    this.initAnimations()
    window.addEventListener('resize', this.handleResize)
    this.handleResize() // Проверить сразу при монтировании
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize)
  },

  methods: {
    // переключатель языка
    switchLang(lang) {
      this.$i18n.locale = lang
    },

    // анимации
    initAnimations() {
      // Активируем анимацию кривой (только если она видна)
      if (this.showCurve) {
        setTimeout(() => {
          const curveLine = document.querySelector('.curve-line')
          if (curveLine) {
            curveLine.classList.add('animate-curve')
          }
        }, 100)
      }

      // Функция для проверки видимости элемента
      const isElementInViewport = (el) => {
        const rect = el.getBoundingClientRect()
        return (
          rect.top <= (window.innerHeight || document.documentElement.clientHeight) * 0.9 &&
          rect.bottom >= 0
        )
      }

      // Функция обработки скролла
      const handleScroll = () => {
        const elements = document.querySelectorAll('.animate-element')
        elements.forEach(element => {
          if (isElementInViewport(element)) {
            element.classList.add('animate')
          }
        })
      }

      // Запуск при загрузке и при скролле
      window.addEventListener('load', handleScroll)
      window.addEventListener('scroll', handleScroll)
      handleScroll() // Проверить сразу
    },

    handleResize() {
      this.showCurve = window.innerWidth > 768
    }
  }
}
</script>


<style scoped>
*{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: "Roboto";
}



.section-pure-img{
  margin-bottom: 30px;
  padding: 5px;
  border: 1px solid rgba(15, 131, 129, .14);
}

.section-pure-img img {
  display: block;
  max-width: 100%;
  margin: 0 auto;
}



/* ==== БАЗОВЫЕ СТИЛИ (для десктопа) ==== */
.section-pure {
  position: relative;
  max-width: 1200px;
  margin: 70px auto;
  padding: 0 20px;
  display: grid;
  row-gap: 50px;
}

.section-pure-title {
  color: #343635;
  font-size: 20px;
  font-weight: 300;
  line-height: 48px;
  margin-bottom: 30px;
  text-align: center;
}

.section-pure-block {
  width: 100%;
  height: auto;
  text-align: left;
  border-radius: 10px;
  padding: 20px;
}

ul {
  list-style: none;
  display: grid;
  row-gap: 10px;
  margin-top: 15px;
}

ul li {
  font-size: 14px;
  font-family: "Roboto";
  font-weight: 300;
  line-height: 28px;
}

h2 {
  font-size: 20px;
  font-family: "Roboto";
  font-weight: 400;
  margin-bottom: 10px;
}

p {
  font-size: 16px;
  font-family: "Roboto";
  font-weight: 300;
  margin-top: 15px;
  line-height: 28px;
}

/* ==== 2K ЭКРАНЫ ==== */
@media (min-width: 1600px) {
  .section-pure {
    max-width: 1400px;
  }
  .section-pure-title {
    font-size: 48px;
    line-height: 60px;
  }
  h2 {
    font-size: 28px;
  }
  ul li, p {
    font-size: 20px;
    line-height: 32px;
  }
}

/* ==== НОУТБУКИ (до 1200px) ==== */
@media (max-width: 1200px) {
  .section-pure-title {
    font-size: 32px;
    line-height: 44px;
  }
  h2 {
    font-size: 22px;
  }
  ul li, p {
    font-size: 17px;
    line-height: 26px;
  }
}

/* ==== ПЛАНШЕТЫ (до 992px) ==== */
@media (max-width: 992px) {
  .section-pure {
    padding: 0 15px;
    row-gap: 40px;
  }
  .section-pure-title {
    font-size: 28px;
    line-height: 38px;
  }
  h2 {
    font-size: 20px;
  }
  ul li, p {
    font-size: 16px;
    line-height: 24px;
  }
}

/* ==== МОБИЛЬНЫЕ (до 768px) ==== */
@media (max-width: 768px) {
  .section-pure {
    margin: 40px auto;
    row-gap: 30px;
  }
  .section-pure-title {
    font-size: 24px;
    line-height: 32px;
    margin-bottom: 20px;
  }
  h2 {
    font-size: 18px;
  }
  ul li, p {
    font-size: 15px;
    line-height: 22px;
  }
  .curve-line {
    display: none; /* скрываем кривую на мобилках */
  }
}

/* ==== СМАРТФОНЫ (до 480px) ==== */
@media (max-width: 480px) {
  .section-pure {
    padding: 0 10px;
  }
  .section-pure-title {
    font-size: 20px;
    line-height: 28px;
  }
  h2 {
    font-size: 16px;
  }
  ul li, p {
    font-size: 14px;
    line-height: 20px;
  }
}






/* Анимационные стили */
.animate-element {
  transform: translateX(-100px);
  opacity: 0;
  transition: transform 0.6s ease-out, opacity 0.6s ease;
}

.animate {
  transform: translateX(0) !important;
  opacity: 1 !important;
}

/* Кривая линия - перемещена левее контента */
.curve-line {
  position: absolute;
  top: 0;
  left: -100px;
  width: 100px;
  height: 100%;
  z-index: -1;
}

.curve-svg {
  width: 100%;
  height: 100%;
}

.curve-path {
  fill: none;
  stroke: #0b8482;
  stroke-width: 2;
  stroke-dasharray: 1000;
  stroke-dashoffset: 1000;
  transition: stroke-dashoffset 2s ease-in-out;
}

.animate-curve .curve-path {
  stroke-dashoffset: 0;
}

/* Адаптация для мобильных устройств */
@media (max-width: 768px) {
  .page-container {
    padding: 0 15px;
    margin: 40px auto;
  }
  
  .curve-line {
    display: none; /* Скрываем линию на мобильных */
  }
  
  .animate-element {
    transform: translateX(-50px); /* Меньшее смещение для мобильных */
  }
  
  .silimed-buttons {
    flex-direction: column;
    height: auto;
    gap: 15px;
  }
  
  .silimed-buttons a {
    width: 100%;
    line-height: 50px;
  }
  
  .features {
    flex-direction: column;
    align-items: center;
  }
  
  .feature-card {
    max-width: 100%;
    min-height: auto;
    margin-bottom: 30px;
  }
}
</style>